import React, { useState, useEffect, useContext } from "react";
import "../../api_partner/custom-tabs.css";
import { Badge, Button, Form, Modal } from "react-bootstrap";
import swal from "sweetalert";
import { GlobalContext } from "../../Context/GlobalState";
import { BASE_URL_APISERVICES, BASE_URL_API } from "../../utils/Constants";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import Select from "react-select";
import { ExportToExcel, excelMapping } from "../../utils/utilFuctions";
import { getLatLong, getClientIP } from "../../utils/utilFuctions";
import { adminAuth } from "../../config";

const APITopupAdmin = () => {
  const [agentId, setAgentId] = useState("");

  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const positionStyle1 = {
    position: "absolute",
    top: -38,
    left: 0,
    fontFamily: "Poppins",
    color: "rgba(255, 255,255, 1)",
  };

  return (
    <div id="secure-ui" className="p-4 bg-light" style={{ fontFamily: "auto" }}>
      <div style={{ background: "#fff" }}>
        {" "}
        <div
          className="row justify-content-start m-0 px-4 py-2"
          style={{ background: "" }}
        >
          <h2
            style={{
              margin: "0",
              fontWeight: "bolder",
            }}
          >
            Vendor List
          </h2>
        </div>
      </div>
      <div>
        <div>
          <div className="card m-0 p-0 pt-3">
            <div className="card-body m-0 p-0">
              <div className="">
                <div
                  defaultActiveKey="profile"
                  className=" tab-header justify-content-start"
                >
                  <div
                    className={`tab-item ${activeTab === 0 ? "active" : ""}`}
                    onClick={() => handleTabClick(0)}
                  >
                    Vendor List
                  </div>
                  <div
                    className={`tab-item ${activeTab === 1 ? "active" : ""}`}
                    onClick={() => handleTabClick(1)}
                  >
                    Vendor Topup Report
                  </div>
                </div>
                <div className="tab-content">
                  {activeTab === 0 && (
                    <div>
                      <VendoList2 agentId={agentId} />
                    </div>
                  )}
                  {activeTab === 1 && (
                    <div>
                      <VendorTopupReport agentId={agentId} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const VendoList = ({ group_name, showModal2, setShowModal2 }) => {
  const { username1, password1 } = adminAuth;
  const accountList = [
    { label: "YES BANK [001463400003400]", value: "001463400003400" },
    { label: "YES BANK [001463400006363]", value: "001463400006363" },
    { label: "IDFC [10191997124]", value: "435111000023" },
  ];
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [formData, setFormData] = useState({
    signerName: "",
    signerEmail: "",
    signerCity: "",
    purpose: "",
    pdfFile: null,
    numPages: null,
    file: null,
  });

  const [state, setState] = useState({
    amount: "",
    remark: "",
    topupVia: "",
  });

  const [errors, setErrors] = useState({
    amount: "",
    remark: "",
  });

  const [selectedVendor, setSelectedVendor] = useState({});
  const [input, setInput] = useState({
    vendorName: "",
    bankName: "YES BANK",
    ifsc: "",
    accNo: "",
  });
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [buttonShow, setButtonShow] = useState({
    topup: false
  });
  const OpenModal = () => {
    setShowModal(!showModal);
  };
  const OpenModal2 = () => {
    setShowModal2(!showModal2);
  };

  const getVendorAccounts = async (e) => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        userid: user.pkid,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_ALL_VENDOR_ACC}`,
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {
          if (data?.status == "0") {
            setData(data?.data.filter((e) => e.group_name === group_name));
            setTransactionLoaderState(false);
          } else {
            swal("Error", "Something went wrong", "error");
            setTransactionLoaderState(false);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    } catch (error) { }
  };
  const positionStyle1 = {
    position: "absolute",
    top: -38,
    left: 0,
    fontFamily: "Poppins",
    color: "rgba(255, 255,255, 1)",
  };

  const vendorTopup = async (e) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        adminid: user.pkid,
        vendorid: selectedVendor.id,
        amount: state.amount,
        remarks: state.remark,
        topupVia: state.topupVia.value,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.ADMIN_VENDOR_TOPUP}`,
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {
          if (data?.status == "0") {
            swal("Success", data.msg, "success");
          } else {
            swal("Error", "Something went wrong", "error");
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    } catch (error) { }
  };

  const vendorTopup2 = async (e) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
      );
      var raw = JSON.stringify({
        adminid: user.pkid,
        vendorid: "",
        amount: state.amount,
        remarks: state.remark,
        topupVia: state.topupVia.value,
        accNo: input.accNo,
        accIfsc: input.ifsc,
        vendorName: input.vendorName,
        bankName: input.vendorName,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.ADMIN_VENDOR_TOPUP_V1}`,
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {
          if (data?.status == "0") {
            // setData(data?.data)
            swal("Success", data.msg, "success");
          } else {
            swal("Error", "Something went wrong", "error");
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    } catch (error) { }
  };

  const clearForm = () => {
    setFormData({
      signerName: "",
      signerEmail: "",
      signerCity: "",
      purpose: "",
      pdfFile: null,
      numPages: null,
      file: null,
    });
  };
  const clearForm2 = () => {
    setInput({ vendorName: "", bankName: "", ifsc: "", accNo: "" });
  };

  const disableAccount = (id, status) => {
    swal({
      title: "Are you sure?",
      text: `Archive account ID ${id}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        disableVendorAccount(id, status);
      }
    });
  };

  const disableVendorAccount = async (id, status) => {
    try {
      setTransactionLoaderState(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
      );


      var raw = JSON.stringify({
        accountId: id,
        adminId: user.pkid,
        status: status == "ARCHIVE" ? "ACTIVE" : "ARCHIVE",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.DISABLE_VENDOR_ACC}`,
        requestOptions
      );
      const data = await res.json();
      if (data.responseCode == "00") {
        swal("Success", data.responseMessage, "success");
        getVendorAccounts();
      } else {
        swal("Failed", data.responseMessage, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };

  const get_admin_access_info = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
      );


      let coords = await getLatLong();
      const ip = await getClientIP();

      var raw = JSON.stringify({
        userid: user.pkid,
        lattitude: coords[0],
        longitude: coords[1],
        ip: ip,
        pagename: "API_TOPUP"
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.get_admin_access_info}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status == "0") {

            const apiTopup = result.services.find(
              (service) => service.pk_menu_id === "9"
            );


            setButtonShow({
              topup: apiTopup && apiTopup.status === "Y",
            });

            setTransactionLoaderState(false);

          } else {
            setButtonShow({
              topup: false,
            });
            setTransactionLoaderState(false);
          }
        })
        .catch((error) => console.log("error", error));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getVendorAccounts();
    get_admin_access_info();
  }, []);

  return (
    <div className="m-0">
      <Modal show={showModal} onHide={OpenModal}>
        <Modal.Header closeButton>
          <Modal.Title> Topup Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="card-body m-0 p-1 px-2">
              <div>
                <div className="row ">
                  <div className="col ">
                    <Form.Group>
                      <Form.Label className="text-dark">
                        <span style={{ color: "red" }}>*</span>
                        {`Vendor Name`}
                      </Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        className="form-control rounded-lg"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Enter User ID"
                        value={selectedVendor.vendor_name}
                        style={{ borderRadius: "0px" }}
                      />
                    </Form.Group>
                    {errors.UserID && (
                      <div className="text-danger">{errors.UserID}</div>
                    )}
                  </div>

                  <div className="col">
                    <Form.Group>
                      <Form.Label className="text-dark">
                        <span style={{ color: "red" }}>*</span>
                        {`Account Number`}
                      </Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        className="form-control rounded-lg"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Enter Transaction ID"
                        value={selectedVendor.acc_no}
                        style={{ borderRadius: "0px" }}
                      />
                    </Form.Group>
                    {errors.TransactionID && (
                      <div className="text-danger">{errors.TransactionID}</div>
                    )}
                  </div>
                </div>
                <div className="row ">
                  <div className="col ">
                    <Form.Group>
                      <Form.Label className="text-dark">
                        <span style={{ color: "red" }}>*</span>
                        {`Vendor Ifsc`}
                      </Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        maxLength={10}
                        className="form-control rounded-lg"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Enter Customer Mobile"
                        value={selectedVendor.acc_ifsc}
                        style={{ borderRadius: "0px" }}
                      />
                    </Form.Group>{" "}
                    {errors.Mobile && (
                      <div className="text-danger">{errors.Mobile}</div>
                    )}
                  </div>

                  <div className="col">
                    <Form.Group>
                      <Form.Label className="text-dark">
                        <span style={{ color: "red" }}>*</span>
                        {`Topup Amount`}
                      </Form.Label>
                      <Form.Control
                        type="Number"
                        className="form-control rounded-lg"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Enter Amount"
                        value={state.Name}
                        onChange={(e) => {
                          setState({ ...state, amount: e.target.value });
                        }}
                        style={{ borderRadius: "0px" }}
                      />
                    </Form.Group>{" "}
                    {errors.Name && (
                      <div className="text-danger">{errors.Name}</div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <Form.Group className="p-0 m-0">
                      <Form.Label className="text-dark">
                        <span style={{ color: "red" }}>*</span>
                        {`Topup Via`}
                      </Form.Label>

                      <Select
                        value={state.topupVia}
                        options={accountList}
                        onChange={(e) => {
                          setState({ ...state, topupVia: e });
                        }}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <Form.Group>
                      <Form.Label className="text-dark">
                        <span style={{ color: "red" }}>*</span>
                        {`Remark`}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className="form-control rounded-lg"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Enter Remark"
                        value={state.remark}
                        onChange={(e) => {
                          setState({ ...state, remark: e.target.value });
                        }}
                        style={{ borderRadius: "0px" }}
                      />
                    </Form.Group>{" "}
                    {errors.remark && (
                      <div className="text-danger">{errors.remark}</div>
                    )}
                  </div>
                </div>
                <div className="row ">
                  <div className="col-3 ">
                    <Button
                      className="rounded-10 btn-block "
                      variant="primary"
                      onClick={vendorTopup}
                    >
                      {" "}
                      Submit
                    </Button>
                  </div>
                  <div className="col-3 ">
                    <Button
                      className="rounded-10 btn-block border border-primary"
                      variant="white"
                      onClick={clearForm}
                    >
                      {" "}
                      Clear
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={showModal2} onHide={OpenModal2}>
        <Modal.Header closeButton>
          <Modal.Title> Direct Topup </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="card-body m-0 p-1 px-2">
              <div>
                <div className="row ">
                  <div className="col ">
                    <Form.Group>
                      <Form.Label className="text-dark">
                        <span style={{ color: "red" }}>*</span>
                        {`Vendor Name`}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className="form-control rounded-lg"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Enter Vendor Name"
                        value={input.vendorName}
                        onChange={(e) => {
                          setInput({ ...input, vendorName: e.target.value });
                        }}
                        style={{ borderRadius: "0px" }}
                      />
                    </Form.Group>
                    {errors.UserID && (
                      <div className="text-danger">{errors.UserID}</div>
                    )}
                  </div>

                  <div className="col">
                    <Form.Group>
                      <Form.Label className="text-dark">
                        <span style={{ color: "red" }}>*</span>
                        {`Account Number`}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className="form-control rounded-lg"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Enter Account Number"
                        value={input.accNo}
                        onChange={(e) => {
                          setInput({ ...input, accNo: e.target.value });
                        }}
                        style={{ borderRadius: "0px" }}
                      />
                    </Form.Group>
                    {errors.TransactionID && (
                      <div className="text-danger">{errors.TransactionID}</div>
                    )}
                  </div>
                </div>
                <div className="row ">
                  <div className="col ">
                    <Form.Group>
                      <Form.Label className="text-dark">
                        <span style={{ color: "red" }}>*</span>
                        {`Vendor Ifsc`}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className="form-control rounded-lg"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Enter IFSC"
                        value={input.ifsc}
                        onChange={(e) => {
                          setInput({ ...input, ifsc: e.target.value });
                        }}
                        style={{ borderRadius: "0px" }}
                      />
                    </Form.Group>{" "}
                    {errors.Mobile && (
                      <div className="text-danger">{errors.Mobile}</div>
                    )}
                  </div>

                  <div className="col">
                    <Form.Group>
                      <Form.Label className="text-dark">
                        <span style={{ color: "red" }}>*</span>
                        {`Topup Amount`}
                      </Form.Label>
                      <Form.Control
                        type="Number"
                        className="form-control rounded-lg"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Enter Amount"
                        value={state.Name}
                        onChange={(e) => {
                          setState({ ...state, amount: e.target.value });
                        }}
                        style={{ borderRadius: "0px" }}
                      />
                    </Form.Group>{" "}
                    {errors.Name && (
                      <div className="text-danger">{errors.Name}</div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <Form.Group className="p-0 m-0">
                      <Form.Label className="text-dark">
                        <span style={{ color: "red" }}>*</span>
                        {`Topup Via`}
                      </Form.Label>

                      <Select
                        value={state.topupVia}
                        options={accountList}
                        onChange={(e) => {
                          setState({ ...state, topupVia: e });
                        }}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <Form.Group>
                      <Form.Label className="text-dark">
                        <span style={{ color: "red" }}>*</span>
                        {`Remark`}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        className="form-control rounded-lg"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Enter Remark"
                        value={state.remark}
                        onChange={(e) => {
                          setState({ ...state, remark: e.target.value });
                        }}
                        style={{ borderRadius: "0px" }}
                      />
                    </Form.Group>{" "}
                    {errors.remark && (
                      <div className="text-danger">{errors.remark}</div>
                    )}
                  </div>
                </div>
                <div className="row ">
                  <div className="col-3 ">
                    <Button
                      className="rounded-10 btn-block "
                      variant="primary"
                      onClick={vendorTopup2}
                    >
                      {" "}
                      Submit
                    </Button>
                  </div>
                  <div className="col-3 ">
                    <Button
                      className="rounded-10 btn-block border border-primary"
                      variant="white"
                      onClick={clearForm2}
                    >
                      {" "}
                      Clear
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div className="m-0 p-0 card mx-3 center-block scroll-inner">
        <table
          className="dashboard-table-style"
          style={{ width: "100%", overflowX: "auto" }}
        >
          <tr>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              Sr
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              vendor_name
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              account
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              ifsc
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              bank
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              Tag
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              Txn Mode
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              Action
            </th>
          </tr>

          {data.map((e, ind) => (
            <tr key={ind}>
              <td style={{ fontSize: "1rem" }}>{ind + 1}</td>
              <td style={{ fontSize: "1rem" }}>{e.vendor_name}</td>
              <td style={{ fontSize: "1rem" }}>{e.acc_no}</td>
              <td style={{ fontSize: "1rem" }}>{e.acc_ifsc}</td>
              <td style={{ fontSize: "1rem" }}>{e.bank_name}</td>

              <td style={{ fontSize: "1rem" }}>
                {Array.isArray(e.tags) && e.tags.length > 0 ? (
                  <div
                    style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}
                  >
                    {e.tags.map((tag, i) => {
                      const badgeThemes = [
                        { bg: "#e6f4ea", color: "#2e7d32", border: "#a5d6a7" },
                        { bg: "#e3f2fd", color: "#1565c0", border: "#90caf9" },
                        { bg: "#fff3e0", color: "#ef6c00", border: "#ffcc80" },
                        { bg: "#fce4ec", color: "#ad1457", border: "#f48fb1" },
                        { bg: "#f3e5f5", color: "#6a1b9a", border: "#ce93d8" },
                        { bg: "#e0f7fa", color: "#00838f", border: "#80deea" },
                        { bg: "#fbe9e7", color: "#d84315", border: "#ffab91" },
                        { bg: "#ede7f6", color: "#4527a0", border: "#b39ddb" },
                      ];
                      const theme = badgeThemes[i % badgeThemes.length];
                      return (
                        <span
                          key={i}
                          style={{
                            backgroundColor: theme.bg,
                            color: theme.color,
                            border: `1px solid ${theme.border}`,
                            padding: "4px 10px",
                            borderRadius: "20px",
                            fontSize: "0.75rem",
                            fontWeight: "500",
                            textTransform: "capitalize",
                          }}
                        >
                          {tag}
                        </span>
                      );
                    })}
                  </div>
                ) : (
                  <span style={{ color: "#999" }}>—</span>
                )}
              </td>

              <td style={{ fontSize: "1rem" }}>{e.txn_mode}</td>

              <td style={{ fontSize: "1rem" }}>
                <Button
                  disabled={!buttonShow?.topup}
                  className="btn btn-sm btn-primary"
                  onClick={() => {
                    setSelectedVendor(e);
                    OpenModal();
                  }}
                >
                  Topup
                </Button>
                {e.status === "Y" ? (
                  <button
                    className="btn btn-sm btn-warning"
                    onClick={() => disableAccount(e.id, e.status)}
                  >
                    Archive
                  </button>
                ) : (
                  <button
                    className="btn btn-sm btn-success"
                    onClick={() => disableAccount(e.id, e.status)}
                  >
                    Activate
                  </button>
                )}
              </td>
            </tr>
          ))}
        </table>
      </div>
    </div>
  );
};

const VendoList2 = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [showModal2, setShowModal2] = useState(false);
  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const { user } = useContext(GlobalContext);

  return (
    <div className="">
      <div
        defaultActiveKey="profile"
        className=" tab-header justify-content-start"
      >


        {(user.pkid == "1" || user.pkid == "9") && (
          <div className="m-2 mt-3">
            <Button
              className="rounded-10 btn-sm btn-primary mx-5 my-auto"
              onClick={() => {
                setShowModal2(true);
              }}
            >
              Direct Topup
            </Button>
          </div>
       )} 


        <div
          className={`tab-item ${activeTab === 0 ? "active" : ""}`}
          onClick={() => handleTabClick(0)}
        >
          Api Providers
        </div>
        <div
          className={`tab-item ${activeTab === 1 ? "active" : ""}`}
          onClick={() => handleTabClick(1)}
        >
          Bumppy
        </div>
        <div
          className={`tab-item ${activeTab === 4 ? "active" : ""}`}
          onClick={() => handleTabClick(4)}
        >
          Rajneesh
        </div>
        <div
          className={`tab-item ${activeTab === 5 ? "active" : ""}`}
          onClick={() => handleTabClick(5)}
        >
          Pooja
        </div>
        <div
          className={`tab-item ${activeTab === 6 ? "active" : ""}`}
          onClick={() => handleTabClick(6)}
        >
          Maintenance
        </div>
        <div
          className={`tab-item ${activeTab === 2 ? "active" : ""}`}
          onClick={() => handleTabClick(2)}
        >
          Favourite
        </div>
        <div
          className={`tab-item ${activeTab === 3 ? "active" : ""}`}
          onClick={() => handleTabClick(3)}
        >
          Other
        </div>
      </div>
      <div className="tab-content">
        {activeTab === 0 && (
          <div>
            <VendoList
              setShowModal2={setShowModal2}
              showModal2={showModal2}
              group_name={"API_VENDOR"}
            />
          </div>
        )}
        {activeTab === 1 && (
          <div>
            <VendoList
              setShowModal2={setShowModal2}
              showModal2={showModal2}
              group_name={"BUMPPY"}
            />
          </div>
        )}
        {activeTab === 3 && (
          <div>
            <VendoList
              setShowModal2={setShowModal2}
              showModal2={showModal2}
              group_name={"OTHER"}
            />
          </div>
        )}
        {activeTab === 2 && (
          <div>
            <VendoList
              setShowModal2={setShowModal2}
              showModal2={showModal2}
              group_name={"FAVOURITE"}
            />
          </div>
        )}
        {activeTab === 4 && (
          <div>
            <VendoList
              setShowModal2={setShowModal2}
              showModal2={showModal2}
              group_name={"RAJNEESH"}
            />
          </div>
        )}
        {activeTab === 5 && (
          <div>
            <VendoList
              setShowModal2={setShowModal2}
              showModal2={showModal2}
              group_name={"POOJA"}
            />
          </div>
        )}
        {activeTab === 6 && (
          <div>
            <VendoList
              setShowModal2={setShowModal2}
              showModal2={showModal2}
              group_name={"MAINTENANCE"}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export const columns = [
  {
    dataField: "orderid",
    text: "order id",
  },
  {
    dataField: "rrn",
    text: "Bank RRN",
  },
  {
    dataField: "vendor",
    text: "vendor",
  },
  {
    dataField: "acc_no",
    text: "Aaccount No",
  },
  {
    dataField: "acc_ifsc",
    text: "IFSC Code",
  },
  {
    dataField: "amount",
    text: "Amount",
  },
  {
    dataField: "indate",
    text: "Date",
  },
];

const VendorTopupReport = () => {
  const now = (date = new Date()) => {
    return `${date.getFullYear()}-${date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
      }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
  };
  const { username1, password1 } = adminAuth;
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [formData, setFormData] = useState({
    signerName: "",
    signerEmail: "",
    signerCity: "",
    purpose: "",
    pdfFile: null,
    numPages: null,
    file: null,
  });

  const [state, setState] = useState({
    amount: "",
  });

  const [errors, setErrors] = useState({
    amount: "",
  });

  const [selectedOption, setSelectedOption] = useState("");

  const [selectedVendor, setSelectedVendor] = useState({});
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const OpenModal = () => {
    setShowModal(!showModal);
  };

  const positionStyle1 = {
    position: "absolute",
    top: -38,
    left: 0,
    fontFamily: "Poppins",
    color: "rgba(255, 255,255, 1)",
  };

  const getVendorAccounts = async (e) => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        userid: user.pkid,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_ALL_VENDOR_TOPUP}`,
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {
          if (data?.status == "0") {
            setData(data?.data);
            setTransactionLoaderState(false);
          } else {
            swal("Error", "Something went wrong", "error");
            setTransactionLoaderState(false);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    } catch (error) { }
  };

  const vendorTopup = async (e) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        adminid: user.pkid,
        vendorid: selectedVendor.id,
        amount: state.amount,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.ADMIN_VENDOR_TOPUP}`,
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {
          if (data?.status == "0") {
            // setData(data?.data);
            swal("Success", "Topup Success", "success");
          } else {
            swal("Error", "Something went wrong", "error");
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    } catch (error) { }
  };
  const twoDecimalPlaces = (amount) => {
    return Number(amount).toFixed(2);
  };
  const clearForm = () => {
    setFormData({
      signerName: "",
      signerEmail: "",
      signerCity: "",
      purpose: "",
      pdfFile: null,
      numPages: null,
      file: null,
    });
  };

  const getPayoutStatus = async (orderid) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
      );


      var raw = JSON.stringify({
        // "payoutId": tid
        txnId: orderid,
        service: "VENDOR_TOPUP",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_PAYOUT_STATUS}`,
        requestOptions
      );
      const data = await res.json();

      if (data.responseCode === "00") {
        swal(
          "Success",
          `Status : ${data.data?.status}\nRRN : ${data.data?.endToEndIdentification}`,
          "success"
        );
      } else {
        swal("Failed", `${data.responseMsg}`, "error");
      }
    } catch (error) {
      console.error("Error occurred:", error);
      swal("Failed", `Something went wrong`, "error");
    }
  };

  useEffect(() => {
    getVendorAccounts();
  }, []);

  return (
    <div className="card m-3 p-4">
      <div className="row m-0 p-0 pt-1 align-items-center">
        <div className="col-3 m-0 p-0">
          <div
            className="m-0 p-0 pl-3 align-top"
            style={{
              fontFamily: "Poppins",
              fontWeight: "600",
              lineHeight: "48px",
              letterSpacing: "0em",
              textAlign: "left",
              padding: "0px",
              background: "#FFFFFF",
              color: "#4267B2",
              fontWeight: "bolder",
              fontfamily: "Poppins !impotent",
              fontSize: "28px",
            }}
          >
            Vendor Topup Report
          </div>
        </div>

        <div className="col-9 m-0 p-0 ">
          <div className="row m-0 p-0 justify-content-end">
            <div
              className="pr-1 pl-2 p-0 m-0"
              style={{ width: "18%", height: "20%" }}
            ></div>
            <div
              className="px-1 p-0 m-0"
              style={{ width: "18%", height: "20%" }}
            ></div>

            <div
              className="pl-1 p-0 m-0"
              style={{ width: "14%", height: "20%" }}
            ></div>

            <div
              className="m-0 p-0 hover-container"
              style={{ cursor: "pointer" }}
              onClick={() => {
                ExportToExcel(
                  `Vendor_Topup_Report${now()}`,
                  excelMapping(data, columns)
                );
              }}
            >
              <img
                className="pl-1 p-0"
                src={require("../../../assets/images/download Icon.png")}
                style={{ width: `3.5rem`, height: "85%" }}
              />
              <div style={positionStyle1} className="hover-text bg-dark ">
                Export to Excel
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ overflowX: "auto", width: "100%" }}>
        <table
          className="dashboard-table-style"
          style={{ width: "100%", overflowX: "auto" }}
        >
          <tr>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              {" "}
              {"Sr"}
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              order id
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              Bank RRN
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              vendor{" "}
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              account
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              Amount
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              Remark
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              Top-up By
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              date
            </th>
            <th
              className="text-center"
              style={{
                fontSize: "0.9rem",
                background: "#f5f6f8",
                color: "#586275",
              }}
            >
              Action
            </th>
          </tr>
          {data.map((e, ind) => (
            <tr key={ind}>
              <td style={{ fontSize: "1rem" }}>{ind + 1}</td>
              <td style={{ fontSize: "1rem" }}>
                <div>
                  <div>{e.orderid}</div>
                </div>
              </td>
              <td style={{ fontSize: "1rem" }}>{e.rrn}</td>
              <td style={{ fontSize: "1rem" }}>{e.vendor}</td>
              <td style={{ fontSize: "1rem" }}>
                {" "}
                <div>
                  <div>{e.acc_no}</div>
                  <div>{e.acc_ifsc}</div>
                </div>
              </td>
              <td style={{ fontSize: "1rem" }}>{twoDecimalPlaces(e.amount)}</td>
              <td style={{ fontSize: "1rem" }}>{e.remarks}</td>
              <td style={{ fontSize: "1rem" }}>{e.topupBy}</td>
              <td style={{ fontSize: "1rem" }}>{e.indate}</td>
              <td>
                {" "}
                <Button
                  style={{
                    borderRadius: "5px",
                    border: "1px none",
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    color: "rgba(255, 164, 27, 1)",
                    bordercolor: "rgba(255, 255, 255, 1)",
                  }}
                  className="btn btn-sm rounded-100 m-0 p-0"
                  onClick={() => {
                    getPayoutStatus(e.orderid);
                  }}
                >
                  {" "}
                  <div className="hover-container">
                    <img
                      src={require("../../../assets/images/Raise Ticket.png")}
                      style={{ width: "2.1rem" }}
                    />
                    <div style={positionStyle1} className="hover-text bg-dark">
                      {" "}
                      Generate RRN
                    </div>
                  </div>
                </Button>
              </td>
            </tr>
          ))}
        </table>
      </div>
    </div>
  );
};

export default APITopupAdmin;
